//package imports
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Formik, useFormik } from 'formik';
import osanLogoImg from "../../assests/images/osanLogo1.webp"

//componenet imports
import CustomTextField from "../../utils/resuableComponents/CustomTextfield";
import { CustomDropdown } from "../../utils/resuableComponents/CustomDropdown";
import { getStateList, getUserType } from "../../services/apiServices/GetServices";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { GetCityList } from "../../services/apiServices/PostServices";
import { UpdateUserApi, ValidateEmail, ResendEmailOtp, CreateUserApi } from "../../services/apiServices/PostServices";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { showToast } from "../../utils/constants/Toaster";
import { getData, removeData } from "../../utils/AsyncStorage";
import { storeData } from "../../utils/AsyncStorage";
import Loader from "../loadingScreens/Loader";
import CreateProfile from "../auth/CreateProfile"


const AdminCreateProfile = (props) => {

    return (
        <div class="container-fluid p-0 ">
            <CreateProfile/>

        </div>
    )
}


export default AdminCreateProfile